import { call, put, takeEvery } from "redux-saga/effects";
import * as types from "./unassignedProviderListActionType";
import * as actions from "./unassignedProviderListActions";
import * as services from "./unassignedProviderListServices";
import SweetAlert from "../../../../components/sweetalert/SweetAlert";

function* fetchUnassignedProviderListSaga(action) {
  try {
    const response = yield call(
      services.getUnassignedProviderList,
      action.payload || {},
    );

    if (response?.success) {
      yield put(
        actions.fetchUnassignedProviderListSuccess(response.values || []),
      );
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to fetch unassigned providers";
      yield put(actions.fetchUnassignedProviderListFailure(errorMessage));
      SweetAlert.error({ title: "Error!", text: errorMessage });
    }
  } catch (error) {
    const errorMessage = "Failed to fetch unassigned providers";
    console.error("Unassigned Provider List Fetch Error:", error);
    yield put(actions.fetchUnassignedProviderListFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

export default function* watchUnassignedProviderListSaga() {
  yield takeEvery(
    types.FETCH_UNASSIGNED_PROVIDER_LIST_REQUEST,
    fetchUnassignedProviderListSaga,
  );
}